<template>
  <div class="row">
    <div class="col p-0">
      <!-- تب های سربرگ محتویات سند -->
      <ul class="nav nav-tabs">
        <!-- تب لیست اسناد -->
        <li class="nav-item activeNav rounded-top">
          <a
            href="#tabListDoc"
            id="home-tab"
            class="
              nav-link
              active
              d-flex
              justify-content-between
              align-items-center
            "
            @click="ChangeTab(1)"
            data-toggle="tab"
          >
            لیست اسناد
          </a>
        </li>
        <!-- تب لیست حساب‌ها -->
        <li class="nav-item rounded-top">
          <a
            href="#tabListRecord"
            id="profile-tab"
            class="nav-link d-flex justify-content-between align-items-center"
            @click="ChangeTab(2)"
            data-toggle="tab"
          >
            لیست حساب‌ها
          </a>
        </li>
      </ul>

      <!-- بدنه محتویات تب ها -->
      <div class="tab-content rounded shadow z-depth-1 p-1">
        <!-- بدنه تب لیست اسناد -->
        <div class="tab-pane fade show active w-100" id="tabListDoc">
          <keep-alive>
            <Tab1_ListSanad></Tab1_ListSanad>
          </keep-alive>
        </div>

        <!-- بدنه تب لیست حساب ها -->
        <div class="tab-pane fade w-100" id="tabListRecord">
          <keep-alive>
            <Tab2_ListHesab></Tab2_ListHesab>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import Tab1_ListSanad from "./Components/Tab1_ListSanad.vue"
import Tab2_ListHesab from "./Components/Tab2_ListHesab.vue"


export default {
  components: {
    Tab1_ListSanad,
    Tab2_ListHesab
  },
  data() {
    return {

    };
  },
  methods: {
    ChangeTab(value){
      console.log('tab : ', value);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListDocInfo/ListDocInfo.vue